import { FC, useState } from 'react';
import { Link } from 'react-router-dom';
import { numWord } from '../../../../../helpers/formatters';
import Plus from '../../../../Icons/Plus';
import Minus from '../../../../Icons/Minus';
import clsx from 'clsx';
import styles from './History.module.scss';
import downloadCsv from './downloadCsv';
import { IDoc } from '../../../../../types/orders';
import { DateTime } from 'luxon';
import { generateImageUrl } from '../../../../../helpers/generateImageUrl';

export interface IHistory {
  data: {
    id: string;
    date: string;
    items: {
      id: string;
      name: string;
      cmmf: string;
      status: string;
      comment?: string;
      count: number;
      image: string;
    }[];
  }[];
}

export interface IHistoryItem {
  id: string;
  date: string;
  items: {
    id: string;
    name: string;
    cmmf: string;
    comment?: string;
    count: number;
    status: string;
    image: string;
  }[];
}

const HistoryItem: FC<IDoc> = ({ orderId, creationDate, items }: IDoc) => {
  const [show, setShow] = useState(false);
  return (
    <div className={styles.order_holder}>
      <div className={styles.order_row}>
        <h2>№{orderId}</h2>
        <span>
          {DateTime.fromISO(creationDate)
            .setLocale('ru')
            .toFormat('d MMMM yyyy')}
        </span>
        <span className={styles.count}>
          {items.length}{' '}
          {numWord(items.length, ['позиция', 'позиции', 'позиций'])}
        </span>
        <div className={styles.btn_export_holder}>
          <button
            className={styles.export_btn}
            onClick={() =>
              downloadCsv(
                items.map((item) => {
                  return {
                    article_number: item.article_number,
                    status: item.status,
                    count: item.count,
                    comment: item.comment,
                  };
                }),
              )
            }
          >
            Экспорт (CSV)
          </button>
        </div>
        <div className={styles.btn_show_holder}>
          <button
            className={styles.show_btn}
            onClick={() => (!show ? setShow(true) : setShow(false))}
          >
            Посмотреть состав
            <div className={styles.icon}>{!show ? <Plus /> : <Minus />}</div>
          </button>
        </div>
      </div>
      <div className={clsx(styles.order_items, { [styles.show]: show })}>
        {items.map((item, index) => (
          <div key={index} className={styles.item}>
            <div className={styles.holder}>
              <img
                src={
                  item.image
                    ? generateImageUrl(item.image)
                    : '/images/placeholderImage.png'
                }
                className={styles.image}
                alt=""
              />
              <div className={styles.content}>
                <Link
                  to={'/product/' + item.product_id}
                  state={{ type: 'part' }}
                >
                  {item.name}
                </Link>
                <span>{item.article_number}</span>
                <span className={styles.count_mob}>{item.count} шт.</span>
                {item.comment && (
                  <span className={styles.comment}>
                    <img src={'/icons/comment.svg'} alt="comment" />
                    {item.comment}
                  </span>
                )}
              </div>
              <span className={styles.count}>{item.count} шт.</span>
            </div>
            {item.comment && (
              <span className={styles.comment_mob}>
                <img src={'/icons/comment.svg'} alt="comment" />
                {item.comment}
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

const History: FC<{ data: IDoc[] }> = ({ data }: { data: IDoc[] }) => {
  return (
    <div className={styles.History}>
      {data.map((order, index) => (
        <HistoryItem {...order} key={index} />
      ))}
    </div>
  );
};

export default History;
